<template>
  <a-modal v-if="visible" title="预览" okText="确认" cancelText="下载" width="80vw" visible @cancel="handleClose">
    <template slot="footer">
      <a-button @click="handleDownload"> 下载 </a-button>
      <a-button type="primary" @click="handleClose"> 确认 </a-button>
    </template>
    <a ref="downbtn" style="display: none" :href="url.download" />
    <div style="width: 100%; height: 100%; overflow: hidden;">
      <iframe v-if="type=='pdf'" id="iframe" style="width: 100%; height: calc(100% + 54px); border: 0;margin-top: -54px;" :src="url.preview" />
      <img v-else style="max-width: 100%; max-height: 100%" :src="url.preview" />
    </div>

  </a-modal>
</template>

<script>
export default {
  name: 'FormModel',
  data() {
    return {
      visible: false,
      url: {
        download: null,
        preview: null,
      },
      type: 'pdf',
    };
  },
  methods: {
    show(id,type) {
      this.url.download = `${window.BASE_CONFIG.VUE_APP_BASE_API}/mvc/common-file/downloadById?id=${id}`;
      this.url.preview = `${window.BASE_CONFIG.VUE_APP_BASE_API}/mvc/common-file/PreviewById?id=${id}`;
      this.type = type
      this.visible = true;
    },
    handleClose(e) {
      this.visible = false;
    },
    handleDownload(e) {
      console.log(`url==========${this.url.download}`);
      this.$refs.downbtn.dispatchEvent(new MouseEvent('click'));
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .ant-modal-body {
  height: 500px;
}
</style>
